<template>
	<div id="app">
		<Header :username="user.name" :usermail="user.mail_alias || user.mail"></Header>
		<div id="contentContainer" :style="{width: $route.name === 'settings' ? '95%' : null}">
			<div id="contentWrapper">
				<transition
					name="fade"
					mode="out-in">
					<router-view/>
				</transition>
			</div>
		</div>
		<Footer></Footer>
		<NoUserFound :show="showUserError"></NoUserFound>
	</div>
</template>

<script>

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import {RepositoryFactory} from "./scripts/RepositoryFactory";
import NoUserFound from "./views/dialogs/NoUserFound";

const UserRepository = RepositoryFactory.get('users');

export default {
	name: 'App',
	components: {NoUserFound, Footer, Header},
	data: function () {
		return {
			user: {
				name: 'Tony Stark',
				mail: 'tony.stark@ems.ad-alliance.de'
			},
			userCheckPending: true,
		}
	},
	computed: {
		showUserError() {
			return location.origin.indexOf('localhost') === -1 ? this.$store.state.users.showUserError : false;
		}
	},
	mounted() {
		if (this.getParameterByName('session')) {
			// eslint-disable-next-line no-undef
			sso.saveSsoUser();
			if (this.getParameterByName('mail_alias')) {
				// eslint-disable-next-line no-undef
				let user = sso.getSsoUser();
				user.mail_alias = this.getParameterByName('mail_alias');
				localStorage.setItem('ssoUser', JSON.stringify(user));
			}
			location.href = '/';
		}

		// eslint-disable-next-line no-undef
		let user = sso.getSsoUser();
		if (user) {
			this.user.mail = user.mail;
			this.user.name = user.forename + ' ' + user.lastname;
			this.updateUser();
			this.getDMTUserByMail(user.mail);
		}
	},
	methods: {
		async updateUser() {
			try {
				// eslint-disable-next-line no-undef
				let key = this.$route.query.key;
				if (typeof key === 'undefined') {
					const {data} = await UserRepository.update();
					if (data.status === "updated") {
						if (data.result === null) {
							if (this.$route.name !== "settings") {
								this.$store.commit('users/showUserError', {data: true});
							}
						} else {
							this.$store.commit('users/userExists', {data: true});
						}
					}
				}
			} catch (e) {
				console.log(e);
			} finally {
				this.userCheckPending = false;
			}
		},
		async getDMTUserByMail(mail) {
			this.$store.commit('users/setLoading', true);
			const {data} = await UserRepository.getUserByMail(mail);
			this.$store.commit('users/setCurrentUser', data);
			this.$store.commit('users/setLoading', false);
		},
		getParameterByName(name, url) {
			if (!url) url = window.location.href;
			// eslint-disable-next-line no-useless-escape
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		}
	},
	watch: {
		$route(newRoute) {
			if (this.getParameterByName('session')) {
				// eslint-disable-next-line no-undef
				sso.saveSsoUser();
			}
			if (!this.userCheckPending && newRoute.name !== "settings" && this.$store.state.users.userExists === false) {
				this.$store.commit('users/showUserError', {data: true});
			}
		}
	}

}
</script>

<style lang="scss">
@import '~vuejs-noty/dist/vuejs-noty.css';
@import "assets/styles/icons.css";
@import "assets/styles/tooltip.css";
@import "assets/styles/variables.scss";


* {
	box-sizing: border-box;
	font-family: "Roboto", sans-serif;
}

body {
	margin: 0;
	background: rgb(236,237,239);
	color: #394956;
	height: 100vh;
	display: flex;
	flex-direction: column;
	padding-bottom: 154px;
}

#contentContainer {
	padding: 1em;
	display: flex;
	justify-content: center;
	min-height: calc(100vh - 70px - 154px);
	transition: width .3s ease-in-out;
}

#contentWrapper {
	width: 100%;
	height: 100%;
}

.flex {
	display: flex;
}

@media screen and (min-width: 1025px) {
	#contentContainer {
		width: 85%;
		//  max-width: 1400px;
		margin: auto;
	}
}

@media screen and (max-width: 1355px) {
	#contentContainer {
		width: 90%;
	}
}

@media screen and (max-width: 1225px) {
	#contentContainer {
		width: 95%;
	}
}

@media (min-width: 768px) and (max-width: 1024px) {
	#contentContainer {
		width: 100%;
		padding: 0 10px;
	}
}

@media only screen and (max-width: 768px) {
	#contentContainer {
		width: 100%;
		padding-top: 0;
		padding-bottom: 0 !important;
	}
}


/** TRANSITION **/

.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

/** DOTLOADER CSS **/
.v-spinner .v-dot2 {
	animation-name: colorChange !important;
}

.v-spinner .v-dot3 {
	animation-name: colorChange !important;
}

@keyframes colorChange {
	0%,
	100% {
		background-color: #00b6ed;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	50% {

		background-color: #da2567;
		-webkit-transform: scale(1.0);
		transform: scale(1.0);
	}

	30% {
		background-color: #752b77
	}
}

@-webkit-keyframes colorChange {
	0%,
	100% {
		background-color: #00b6ed;
		-webkit-transform: scale(0);
		transform: scale(0);
	}
	50% {

		background-color: #da2567;
		-webkit-transform: scale(1.0);
		transform: scale(1.0);
	}

	30% {
		background-color: #752b77
	}
}

.noty_theme__metroui.noty_type__info, .noty_theme__metroui.noty_type__information {
	background-color: #eceef0;
	color: #394956;
}
</style>
